

exports.__esModule = true;
exports.$CardMetaData = undefined;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CARD_META_DATA = {
    DEFAULT: {
        fields: {
            address: true,
            cvv: true,
            dob: false,
            expiry: true,
            issue: false,
            phone: false
        },
        length: {
            cvv: 3,
            min: 16,
            max: 16
        },
        luhn: true,
        phoneType: 'Mobile',
        spaces: '4,8,12'
    },

    PLCC: {
        fields: {
            expiry: false,
            cvv: false,
            address: false
        },
        length: {
            min: 10,
            max: 16
        }
    },

    MAESTRO: {
        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
        length: {
            min: 12,
            max: 19
        },
        spaces: '4,8,12,16'
    },

    SWITCH: {
        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
        fields: {
            issue: true
        },
        length: {
            min: 12,
            max: 19
        },
        spaces: '4,8,12,16'
    },

    DINERSCLUB: {
        pattern: /^(36|38|30[0-5])/,
        length: {
            min: 14,
            max: 14
        }
    },

    DISCOVER: {
        pattern: /^(6011|65|64[4-9]|622|36|38|30[0-5])/,
        length: {
            min: 14
        }
    },

    MASTERCARD: {
        pattern: /^(5[1-5]|2(2(2[1-9]|[3-9]\d)|[3-6]\d\d|7[0-1]\d|720))/
    },

    AMEX: {
        pattern: /^3[47]/,
        length: {
            cvv: 4,
            min: 15,
            max: 15
        },
        spaces: '4,10'
    },

    VISA: {
        pattern: /^4/,
        length: {
            min: 13
        },
        subTypes: {
            QIWI: {
                pattern: /^(428122|489049|469395|446942|462012)/
            }
        }
    },

    JCB: {
        pattern: /^(?:2131|1800|35[0-9]{3})/,
        length: {
            min: 15
        }
    },

    CBNATIONALE: {},

    CETELEM: {
        fields: {
            dob: true
        },
        length: {
            max: 19
        },
        spaces: '4,8,12,16'
    },

    COFIDIS: {
        fields: {
            dob: true,
            expiry: false,
            cvv: false
        },
        length: {
            min: 8,
            max: 9
        },
        spaces: '4,8',
        luhn: false
    },

    COFINOGA: {
        fields: {
            dob: true,
            cvv: false
        },
        length: {
            min: 17,
            max: 17
        },
        spaces: '4,8,12,16'
    },

    ELO: {
        pattern: /^9/,
        length: {
            min: 13
        }
    },

    HIPER: {
        pattern: /^6/,
        length: {
            min: 13
        }
    },

    HIPERCARD: {
        pattern: /^7/,
        length: {
            min: 13
        }
    },

    CUPCREDIT: {
        fields: {
            address: false,
            phone: true
        },
        length: {
            max: 19
        }
    },

    CUPAMEXCREDIT: {
        fields: {
            address: false,
            phone: true
        },
        length: {
            cvv: 4,
            min: 15,
            max: 15
        }
    },

    CUPDEBIT: {
        fields: {
            address: false,
            cvv: false,
            expiry: false,
            phone: true
        },
        length: {
            max: 19
        }
    },

    CUPAMEXDEBIT: {
        fields: {
            address: false,
            cvv: false,
            expiry: false,
            phone: true
        },
        length: {
            min: 15,
            max: 15
        }
    }
};

Object.keys(CARD_META_DATA).forEach(function (key) {
    CARD_META_DATA[key] = $.extend(true, {}, CARD_META_DATA.DEFAULT, CARD_META_DATA[key]);
});

Object.keys(CARD_META_DATA).forEach(function (key) {
    CARD_META_DATA[key].spaces = CARD_META_DATA[key].spaces.split(',').map(Number);
});

function getTypeByPattern(cardMetaData, types, number) {
    var result = void 0;
    types.some(function (type) {
        var metaData = cardMetaData[type];
        if (metaData && metaData.pattern && metaData.pattern.test(number)) {
            result = type;
            return true;
        }
    });
    return result;
}

var $CardMetaData = exports.$CardMetaData = {
    getMetaData: function getMetaData(card, field) {
        var cardType = card && card.type || 'DEFAULT';
        if (cardType === 'CUP') {
            cardType = cardType + (card.dualType ? card.dualType : '');
            cardType = cardType + (['DEBIT', 'DEBITCARD'].indexOf(card.productType) > -1 ? 'DEBIT' : 'CREDIT');
        }
        return _squid.$Class.get(CARD_META_DATA[cardType], field);
    },
    getCardType: function getCardType(types, number) {
        var cardType = {};
        if (_angular2['default'].isArray(types) && number) {
            cardType.type = getTypeByPattern(CARD_META_DATA, types, number);
            var metaData = CARD_META_DATA[cardType.type];
            if (metaData && metaData.subTypes) {
                cardType.subType = getTypeByPattern(metaData.subTypes, types, number);
            }
        }
        return cardType;
    }
};

_angular2['default'].value("$CardMetaData", $CardMetaData);
_squid.$Class;


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-card/cardMetaData/index.js
 ** module id = 228
 ** module chunks = 1
 **/